import { HttpApiError, HttpApiGroup } from "@effect/platform";
import { Schema } from "effect";
import { endpoint } from "../auth/endpoint";
import { DatabaseError, DataIntegrityError } from "../auth/errors";

import { DraftMessageId, MessageId } from "../ids/definitions";
import { Attachment } from "../models/shopper-ai/conversation/message/attachment";

const GetMessageAttachmentsResponse = Schema.Struct({
  messageId: MessageId,
  attachments: Schema.Array(Attachment),
});

const GetDraftMessageAttachmentsResponse = Schema.Struct({
  draftMessageId: DraftMessageId,
  attachments: Schema.Array(Attachment),
});

const AddDraftAttachmentRequest = Schema.Struct({
  draftMessageId: DraftMessageId,
  file: Schema.String,
  filename: Schema.String,
  mimeType: Schema.String,
  size: Schema.Number,
});

const AddDraftAttachmentResponse = Schema.Struct({
  attachment: Attachment,
  draftMessageId: DraftMessageId,
});

export const AttachmentGroup = HttpApiGroup.make("attachment")
  .add(
    endpoint.merchant
      .get("getMessageAttachments", "/messages/:messageId/attachments")

      .setPath(Schema.Struct({ messageId: MessageId }))
      .addSuccess(GetMessageAttachmentsResponse)
      .addError(HttpApiError.NotFound)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    endpoint.merchant
      .get(
        "getDraftMessageAttachments",
        "/draft-messages/:draftMessageId/attachments",
      )

      .setPath(Schema.Struct({ draftMessageId: DraftMessageId }))
      .addSuccess(GetDraftMessageAttachmentsResponse)
      .addError(HttpApiError.NotFound)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    endpoint.merchant
      .post("addDraftAttachment", "/draft-attachments")

      .setPayload(AddDraftAttachmentRequest)
      .addSuccess(AddDraftAttachmentResponse)
      .addError(HttpApiError.NotFound)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
